import * as helpers from './helpers.js';
import * as shopify from './shopify.js';
import * as state from './state.js';
import * as Sentry from "@sentry/browser";

let segmentAnalytics = {};

function init() {
  sentry();
  //segment();
  phraseApp();
  // baidu();  // temp - moved to www head
  drift();
  //adRoll();
}

function segment() {
  const keys = {
    segment: {
      production: 'YyFomKbW7SYslFJUlZKkaACryjjMa3dK',
      staging: 'PgkwhcLkuuJFT58zOCsWY3yDzgwUOWWG',
      dev: 'D5n0YpwE03yIjKBEHPgRl7TnaDY9NDZS',
    },
  };

  const env = helpers.getEnvironment();
  const key = keys.segment[env];

  const analytics = window.analytics = window.analytics || [];
  if (!analytics.initialize) {
    if (analytics.invoked)
      window.console && console.error &&
          console.error('Segment snippet included twice.');
    else {
      analytics.invoked = !0;
      analytics.methods = [
        'trackSubmit', 'trackClick', 'trackLink', 'trackForm', 'pageview',
        'identify', 'reset', 'group', 'track', 'ready', 'alias', 'debug',
        'page', 'once', 'off', 'on'
      ];
      analytics.factory = function(t) {
        return function() {
          const e = Array.prototype.slice.call(arguments);
          e.unshift(t);
          analytics.push(e);
          return analytics;
        };
      };
      for (let t = 0; t < analytics.methods.length; t++) {
        const e = analytics.methods[t];
        analytics[e] = analytics.factory(e);
      }
      analytics.load = function(t) {
        const e = document.createElement('script');
        e.type = 'text/javascript';
        e.async = !0;
        e.src = `${
            document.location.protocol === 'https:' ?
                'https://' :
                'http://'}cdn.segment.com/analytics.js/v1/${
            t}/analytics.min.js`;
        const n = document.getElementsByTagName('script')[0];
        n.parentNode.insertBefore(e, n);
      };
      analytics.SNIPPET_VERSION = '4.0.0';
      analytics.load(key);
      analytics.page();
      helpers.callOnLoaded(() => trackTti(analytics));
    }
  }
}

function trackTti(analytics) {
  const performance = helpers.getPerformance();

  analytics.track('TTI', {
    location: {
      hash: window.location.hash,
      host: window.location.host,
      hostname: window.location.hostname,
      href: window.location.href,
      origin: window.location.origin,
      pathname: window.location.pathname,
      port: window.location.port,
      protocol: window.location.protocol,
      search: window.location.search
    },
    performanceTiming: {
      // we have to dump every property,
      // sending the performance.timing shows up empty in Segment for some
      // reason.
      connectEnd: window.performance.timing.connectEnd,
      connectStart: window.performance.timing.connectStart,
      domComplete: window.performance.timing.domComplete,
      domContentLoadedEventEnd:
          window.performance.timing.domContentLoadedEventEnd,
      domContentLoadedEventStart:
          window.performance.timing.domContentLoadedEventStart,
      domInteractive: window.performance.timing.domInteractive,
      domLoading: window.performance.timing.domLoading,
      domainLookupEnd: window.performance.timing.domainLookupEnd,
      domainLookupStart: window.performance.timing.domainLookupStart,
      fetchStart: window.performance.timing.fetchStart,
      loadEventEnd: window.performance.timing.loadEventEnd,
      loadEventStart: window.performance.timing.loadEventStart,
      navigationStart: window.performance.timing.navigationStart,
      redirectEnd: window.performance.timing.redirectEnd,
      redirectStart: window.performance.timing.redirectStart,
      requestStart: window.performance.timing.requestStart,
      responseEnd: window.performance.timing.responseEnd,
      responseStart: window.performance.timing.responseStart,
      secureConnectionStart: window.performance.timing.secureConnectionStart,
      unloadEventEnd: window.performance.timing.unloadEventEnd,
      unloadEventStart: window.performance.timing.unloadEventStart
    },
    performanceTimingSeconds: performance,
  });

  // log a single metric to focus on
  const elapsedTime = Math.round(performance.domContentLoadedEventEnd * 1000);
  analytics.track('dom-content-loaded', {'value': elapsedTime});
}

function sentry() {
  // load sentry immidiately.
  Sentry.init({
    dsn: "https://6846f642244f41ddaf03955cf6c7b2d9@o88880.ingest.sentry.io/1214231",
    environment: helpers.getEnvironment(),
  });
}

function phraseApp() {
  let query = location.search.substring(1);
  if (!query.includes('i18n')) return;

  window.PHRASEAPP_CONFIG = {projectId: '78cc3e34048febd87d19d4cdefd8593c'};

  (function() {
    var phraseapp = document.createElement('script');
    phraseapp.type = 'text/javascript';
    phraseapp.async = true;
    phraseapp.src = [
      'https://', 'phraseapp.com/assets/in-context-editor/2.0/app.js?',
      new Date().getTime()
    ].join('');
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(phraseapp, s);
  })();
}

function baidu() {
  state.callOnStateLoaded(() => {
    if (shouldLoadBaidu()) loadBaidu();
  });

  function loadBaidu() {
    var _hmt = _hmt || [];
    (function() {
      var hm = document.createElement('script');
      hm.src = 'https://hm.baidu.com/hm.js?2ed2e98d1a2851b9ef89a34aade65510';
      var s = document.getElementsByTagName('script')[0];
      s.parentNode.insertBefore(hm, s);
    })();
  }

  function shouldLoadBaidu() {
    const country = state.getCountryIso();  // lower case
    if (country === 'zh' || country === 'hk') return true;

    const browserLang = state.getBrowserLanguageIso();
    if (browserLang === 'zh') return true;

    const lang = state.getLanguageIso();
    if (lang === 'zh') return true;

    return false;
  }
}

function drift() {
  helpers.callOnFinished(() => {
    // return; //temp only
    // Note: drift is our heaviest processing time consumer at ~500ms on my
    // machine.

    const latencyThusFar = helpers.getTimeSinceNavigationStart();  // seconds
                                                                   /*
                                                                           if( latencyThusFar > 5 ){
                                                                               console.log('skipping drift load');
                                                                               window.analytics.track('skipping-drift', { 'value':
                                                                      latencyThusFar } );                                                                return; // forget it.  Probably on slow network and
                                                                      no reason to gum up the works any more.
                                                                           }
                                                                   */
    // start drift in a few moments.
    window.setTimeout(loadDrift, 2000);
  });

  function loadDrift() {
    !function() {
      var t = window.driftt = window.drift = window.driftt || [];
      if (!t.init) {
        if (t.invoked)
          return void (
              window.console && console.error &&
              console.error('Drift snippet included twice.'));
        t.invoked = !0,
        t.methods =
            [
              'identify', 'config', 'track', 'reset', 'debug', 'show', 'ping',
              'page', 'hide', 'off', 'on'
            ],
        t.factory =
            function(e) {
          return function() {
            var n = Array.prototype.slice.call(arguments);
            return n.unshift(e), t.push(n), t;
          };
        },
        t.methods.forEach(function(e) {
          t[e] = t.factory(e);
        }),
        t.load = function(t) {
          var e = 3e5, n = Math.ceil(new Date() / e) * e,
              o = document.createElement('script');
          o.type = 'text/javascript', o.async = !0, o.crossorigin = 'anonymous',
          o.src = 'https://js.driftt.com/include/' + n + '/' + t + '.js';
          var i = document.getElementsByTagName('script')[0];
          i.parentNode.insertBefore(o, i);
        };
      }
    }();
    window.drift.SNIPPET_VERSION = '0.3.1';
    window.drift.load('4akzufnd7c3p');
  }
}

function adRoll() {
  helpers.callOnFinished(() => {
    window.setTimeout(loadAdRoll, 1000);  // we only care about re-marketing for
                                          // users that spend some time anyway.
  });

  function loadAdRoll() {
    let adroll_adv_id = '2JHPCSQPSNC3BBLTAC2YC5';
    let adroll_pix_id = 'AEBTUC62QRBNDFUIG56P3B';
    (function() {
      var _onload = function() {
        if (document.readyState &&
            !/loaded|complete/.test(document.readyState)) {
          setTimeout(_onload, 10);
          return
        }
        if (!window.__adroll_loaded) {
          __adroll_loaded = true;
          setTimeout(_onload, 50);
          return
        }
        var scr = document.createElement('script');
        var host =
            (('https:' == document.location.protocol) ? 'https://s.adroll.com' :
                                                        'http://a.adroll.com');
        scr.setAttribute('async', 'true');
        scr.type = 'text/javascript';
        scr.src = host + '/j/roundtrip.js';
        ((document.getElementsByTagName('head') || [null])[0] ||
         document.getElementsByTagName('script')[0].parentNode)
            .appendChild(scr);
      };
      if (window.addEventListener) {
        window.addEventListener('load', _onload, false);
      } else {
        window.attachEvent('onload', _onload)
      }
    }());
  }
}

export {
  init,
};
